module.exports = __webpack_public_path__ + "static/img/office-img-3.397e847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office-img-3.jpg
// module id = GCLQ
// module chunks = 0